<template>
	<div>
		<el-dialog 
		:lang="$i18n.locale" 
		:title="dialogTitle" 
		:visible="visible" 
		@update:visible="$emit('update:visible', $event)"
		:close-on-click-modal="false" 
		width="980px"
		:append-to-body="true" 
		@close="handleDialogClose"
	>
		<el-form label-width="150px" :model="dialogForm" ref="OrderForm" :rules="rules" :inline="true">
			<el-form-item :label="$t('commonInfo.orderType')" prop="order_category">
				<el-select v-model="dialogForm.order_category" filterable :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.orderType')" :disabled="isEdit" style="width: 650px;">
					<el-option v-for="item in order_categoryList" :key="item.dictCode" :label="item.dictLabel"
						:value="item.dictValue"></el-option>
				</el-select>
			</el-form-item>
			<div v-if="dialogForm.order_category == 'OWH'">
			  <!-- 自提不需要显示仓库和地址，默认飞坦海外仓，需要填写联系人和联系方式 -->
			  <el-form-item :label="$t('commonInfo.deliveryMode')" prop="deliveryType">
			  	<el-radio v-model="dialogForm.deliveryType" label="1">{{$t('commonInfo.homeDeliveryService')}}</el-radio>
			  	<el-radio v-model="dialogForm.deliveryType" label="2">{{$t('commonInfo.whSelfPickup')}}</el-radio>
			  </el-form-item>
			</div>
			<div v-if="dialogForm.order_category != '' && dialogForm.order_category != 'FFM'">
				<el-form-item v-if="dialogForm.order_category != 'DS'" :label="$t('commonInfo.warhouseCode')" prop="receiver_address">
					<el-tag v-if="dialogForm.deliveryType == '2'" type="success">{{$t('commonInfo.fleetanWarehouse')}}</el-tag>
					<el-select v-else v-model="dialogForm.receiver_address" filterable :placeholder="$t('tipsInfo.selectPlaceholder') + $t('commonInfo.deliveryWarehouse')" style="width: 650px;">
						<el-option v-for="item in selectWhList" :key="item.dictCode" :label="item.dictLabel"
							:value="item.dictValue"></el-option>
					</el-select>
				</el-form-item>
				<CustomerAddressSelector :visible="dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom'" country="SA" @select="applyCustomerAddress" />
				<!-- OWH 送货上门 自定义仓库需要填写地址详情 -->
				<el-form-item v-if="dialogForm.receiver_address == 'custom' || dialogForm.deliveryType == '2'"  :label="$t('commonInfo.deliveryDest')" prop="receiver_detail_address">
    				<el-input style="width: 650px;" v-model="dialogForm.receiver_detail_address" :disabled="dialogForm.deliveryType == '2'"
    					:placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.deliveryDest')"></el-input>
    			</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom'"
    				:label="$t('commonInfo.city')" prop="destCity">
    				<el-select v-model="dialogForm.destCity" filterable
    					:placeholder="$t('tipsInfo.selectPlaceholder') + $t('commonInfo.city')"
    					style="width: 650px;">
    					<el-option v-for="item in saCityList" :key="item.dictCode" :label="item.dictLabel"
    						:value="item.dictLabel"></el-option>
    				</el-select>
    			</el-form-item>
				<el-form-item v-if="dialogForm.deliveryType == '2' || (dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom')"  :label="dialogForm.deliveryType == '1'?$t('commonInfo.contactMan'):$t('commonInfo.consigneeTypeOne')" prop="contacts">
					<el-input v-model="dialogForm.contacts" clearable style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + (dialogForm.deliveryType == '1'?$t('commonInfo.contactMan'):$t('commonInfo.consigneeTypeOne'))"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.deliveryType == '2' || (dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom')"  :label="dialogForm.deliveryType == '1'?$t('commonInfo.contact'):$t('commonInfo.consigneeContact')" prop="contactsTel">
					<el-input v-model="dialogForm.contactsTel" clearable style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + (dialogForm.deliveryType == '1'?$t('commonInfo.contact'):$t('commonInfo.consigneeContact'))"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBA'" :label="$t('commonInfo.fbaNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" maxlength="12" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.fbaNo')"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBA'" :label="$t('commonInfo.fbaNoCode')" prop="fbaNoCode">
					<el-input v-model="dialogForm.fbaNoCode" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.fbaNoCode')"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBN' || dialogForm.order_category == 'SB2B'" :label="$t('commonInfo.asnNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.asnNo')"></el-input>
				</el-form-item>
				<!-- FBN SB2B DS订单类型需要填写店铺ID -->
				<el-form-item v-if="dialogForm.order_category == 'FBN' || dialogForm.order_category == 'SB2B' || dialogForm.order_category == 'DS'" :label="'NOON ' + $t('commonInfo.companyId')" prop="send_company">
					<el-input v-model="dialogForm.send_company" style="width: 650px;"></el-input>
				</el-form-item>
				<!-- OWH类型暂无法知道怎么填写该必传字段，先显示测试 -->
				<el-form-item v-if="dialogForm.order_category == 'OWH'" :label="$t('commonInfo.clientDeliveryNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.clientDeliveryNo')"></el-input>
				</el-form-item>
			</div>
			<div v-if="dialogForm.order_category != ''">
				<el-form-item v-if="dialogForm.order_category == 'FFM'" :label="$t('ksaWhFBXOrderPage.deliveryPlatform')" prop="expressCompany">
					<el-select v-model="dialogForm.expressCompany" filterable :placeholder="$t('tipsInfo.selectPlaceholder') + $t('ksaWhFBXOrderPage.deliveryPlatform')" style="width: 650px;">
						<el-option v-for="item in deliveryPlatformList" :key="item.dictCode" :label="item.dictLabel"
							:value="item.dictValue"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category != 'FBA'" :label="dialogForm.deliveryType == '1'?$t('commonInfo.deliveryDate'):$t('commonInfo.pickupDate') + '(SA)'" prop="delivery_date">
					<el-date-picker
					  clearable
					  style="width: 650px;"
						popper-class="no-atTheMoment"
					    v-model="dialogForm.delivery_date"
						:picker-options="deliveryPickerOptions"
					  :type="dialogForm.order_category == 'OWH'?'date':'datetime'"
					  value-format="yyyy-MM-dd HH:mm:ss"
					  :placeholder="dialogForm.deliveryType == '1'?$t('tipsInfo.selectPlaceholder') + $t('commonInfo.deliveryDate'):$t('tipsInfo.selectPlaceholder') + $t('commonInfo.pickupDate')"
					></el-date-picker>
				</el-form-item>
				<!-- 预约送仓时间提示 -->
				<div class="deliveryTip" v-if="dialogForm.order_category != 'FBA' && !(dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '2')">
					<h4><i class="el-icon-warning"></i>预约送仓时间选择规则：</h4>
					<span>1、选择送仓时间为沙特时间</span>
					<span>2、每周五沙特公休</span>
					<span>3、国内推单当天时间0点-15点为正常推单，</span>
					<label>15点到20点为加急推单，需要收取加急费用，</label>
					<label>20点过后不能推当天单</label>
					<span>4、提前一天以上为正常推单</span>
				</div>
				<el-form-item :label="dialogForm.order_category == 'FFM'?$t('ksaWhFBXOrderPage.packageAmount'):$t('commonInfo.expectedDeliveryQuantity')" prop="clientAppointCount">
					<el-input v-model="dialogForm.clientAppointCount" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" style="width: 650px;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('commonInfo.remark')" prop="exp ">
					<el-input type="textarea" v-model="dialogForm.exp " style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.remark')"></el-input>
				</el-form-item>
			</div>
		</el-form>
		<el-divider><i class="el-icon-box"></i></el-divider>
		<el-form  :inline="true" label-width="auto" style="margin:10px 0 0 15px">
			<el-form-item label>
				<el-input v-model="searchProductCode" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.clientProductCode')" type="textarea" clearable />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-plus" @click="handleSearchProduct">{{$t('commonInfo.addBtn')}}</el-button>
			</el-form-item>
			<el-form-item>
				<el-upload
				  class="upload-demo"
				  :action="$baseUrl + '/toborder/wms/product/addMultiFbxStockProduct'"
				  :before-upload="beforeUpload"
				  :on-success="handlesuccess"
				  :on-error="handleError"
				  :on-progress="handleProgress"
				  multiple
				  :show-file-list="false"
				  :file-list="fileList"
				  accept=".xls, .xlsx"
				  :headers="headers"
				  name="productFile"
				  style="margin-right:15px"
				>
				  <el-button type="success">{{$t('ksaWhFBXOrderPage.multipleImportProduct')}}</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item>
				<el-button @click="handleDownloadUrl">{{$t('commonInfo.downloadTemplate')}}</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="handleDeleteAll">{{$t('commonInfo.deleteAllBtn')}}</el-button>
			</el-form-item>
		</el-form>
		<el-table style="margin:5px 15px;width: calc(100% - 30px)" ref="productTable"
			v-loading="inventoryLoading" :data="inventoryData" :cell-style="cellStyle" border 
			show-summary :summary-method="getSummaries"
			>
			<el-table-column :label="$t('commonInfo.clientProductCode')" width="110" align="center" prop="clientProductCode" />
			<el-table-column :label="$t('commonInfo.productName')" align="center" prop="productNm" />
			<el-table-column prop="img " :label="$t('commonInfo.photo')" align="center" width="80" >
				<template slot-scope="{ row }">
					<img v-if="row.img   != null && row.img   != ''" :src="row.img  " @click="handleViewImg(row.img)" style="width: 60px;height: 60px;"/>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.productQuantity')" align="center" prop="productQuantity" width="80" />
			<el-table-column :label="$t('commonInfo.appointmentQuantity')" align="center" prop="appointmentQuantity" width="130" />
			<el-table-column :label="$t('commonInfo.orderQuantity')" align="center" prop="count">
				<template slot-scope="{ row }">
					<el-input @input="handleNum(row)" v-model.number="row.count" size="small" />
					<span v-if="row.errorNum" style="color: red;font-size: 12px;">{{$t('ksaWhFBXOrderPage.inputCorrectQuantity')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('ksaWhFBXOrderPage.newLabelCode')" align="center" prop="skuNew" width="130">
				<template slot-scope="{ row }">
					<el-input @input="handleNum(row)" v-model="row.skuNew" size="small" />
					<span v-if="row.errorNewSku" style="color: red;font-size: 12px;">{{$t('tipsInfo.inputPlaceholder') + $t('ksaWhFBXOrderPage.newLabelCode')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('ksaWhFBXOrderPage.newLabelQuantity')" align="center" prop="swapCnt">
				<template slot-scope="{ row }">
					<el-input @input="handleNum(row)" v-model.number="row.swapCnt" size="small" />
					<span v-if="row.errorNewNum" style="color: red;font-size: 12px;">{{$t('tipsInfo.inputPlaceholder') + $t('ksaWhFBXOrderPage.newLabelQuantity')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.operationColumn')" align="center" prop="">
				<template slot-scope="{ row }">
					<el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(row.clientProductCode)">{{$t('commonInfo.deleteBtn')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div v-if="!isEdit" style="margin: 10px 0 0 0; display: inline-block;">
			<!-- 上传FBX附件 -->
			<SingleUploadPDF
			  v-if="dialogForm.order_category == 'FBA'"
			  v-model="fbxFlienName"
				:tipText="$t('commonInfo.labelFileTips')"
				:preFile="fbxPreName"
			  @input="getFBXInfo"
				class="fileUploadBtn"
			></SingleUploadPDF>
			<!-- 上传FBN/SB2B 送仓文件 和DS类型客户二维码和仓库二维码 -->
			<SingleUploadPDF
			  v-if="dialogForm.order_category == 'FBN' || dialogForm.order_category == 'SB2B' || dialogForm.order_category == 'DS'"
			  v-model="labelFlienName"
				:tipText="labelTipText"
				:preFile="labelPreName"
			  @input="getLabelInfo"
				class="fileUploadBtn"
			></SingleUploadPDF>
			<!-- 上传FFM 送仓文件 -->
			<MultiFunctionalUpload v-if="dialogForm.order_category == 'FFM'" ref="multiUploadFFMFile" @input="getFFMFile"
			 :tipText="labelTipText" :preFile="preFFMFileList" :fileCount="1">
			</MultiFunctionalUpload>
			<!-- 当用户下单的SKU需要换标时，填写了换标名和数量则需要上传换标附件 -->
			<MutipleUploadNoLimit 
			  v-if="hasSkuNewItem"
			  :tipText="$t('commonInfo.newLabelFileNolimitTips')"
				:isClearList.sync="clearFileListFlag"
			  @input="getNewLabelExcel"
			  class="fileUploadBtn"
			></MutipleUploadNoLimit>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleDialogClose" :disabled="submitLoading">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
			<el-button v-if="isEdit" :disabled="submitLoading" type="danger" @click="handleDel()">{{$t('commonInfo.delete')}}</el-button>
			<el-button type="primary" :loading="submitLoading" @click="submit" :disabled="!openBtn || submitLoading">{{submitLoading?$t('commonInfo.dialogBtnSubmiting'):$t('commonInfo.dialogBtnSubmit')}}</el-button>
		</div>

		<el-image-viewer v-if="showImg" :on-close="closeImg" :url-list="imgList" style="z-index: 9999;"/>
	</el-dialog>
	<!-- 导入Excel后错误的对话框 -->
		<el-dialog :lang="$i18n.locale" :title="$t('commonInfo.productInfo')" :visible.sync="dialogErrorVisible" width="640px" :close-on-click-modal="false">
		  <el-table :data="errorData">
		    <el-table-column property="clientProductCode" :label="$t('commonInfo.clientProductCode')" align="center"></el-table-column>
				<el-table-column property="count" :label="$t('commonInfo.orderQuantity')" align="center"></el-table-column>
				<el-table-column property="errorMsg" :label="$t('commonInfo.result')" align="center">
				</el-table-column>
		  </el-table>
		</el-dialog>
	</div>
</template>

<script>
import SingleUploadPDF from "@/components/upload/singleUploadPDF";
import MutipleUploadNoLimit from "@/components/upload/mutipleUploadNoLimit";
import MultiFunctionalUpload from "@/components/upload/multiFunctionalUpload";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { formatDate, findDuplicates } from "@/utils/index";
import CustomerAddressSelector from "@/components/customerAddress/CustomerAddressSelector";

export default {
	name: 'CreateSkuOrder',
	components: {
		SingleUploadPDF,
		MutipleUploadNoLimit,
		MultiFunctionalUpload,
		ElImageViewer,
		CustomerAddressSelector
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
			return {
				dialogTitle: '创建SKU类型订单',
				dialogForm: {
					order_category: '',
					deliveryType: '1',
					receiver_address: '',
					receiver_detail_address: '',
					fba_no: '',
					fbaNoCode: '',
					send_company: '',
					delivery_date: '',
					clientAppointCount: '',
					exp: '',
					expressCompany: '',
					contacts: '',
					contactsTel: '',
					skuListLink: '',
					label_url: '',
					newLabelLinkList: [],
					order_box_mark: '',
					destCity: ''
				},
				order_categoryList: [
					{
						dictCode: '1',
						dictLabel: 'FBA',
						dictValue: 'FBA'
					},
					{
						dictCode: '2',
						dictLabel: 'FBN',
						dictValue: 'FBN'
					},
					// {
					// 	dictCode: '3',
					// 	dictLabel: 'SB2B',
					// 	dictValue: 'SB2B'
					// },
					{
						dictCode: '4',
						dictLabel: 'OWH',
						dictValue: 'OWH'
					},
					{
						dictCode: '5',
						dictLabel: 'DS',
						dictValue: 'DS'
					},
					{
						dictCode: '6',
						dictLabel: 'FFM',
						dictValue: 'FFM'
					}
				],
				selectWhList: [],
				deliveryPlatformList: [],
				isEdit: false,
				submitLoading: false,
				openBtn: true,
				hasSkuNewItem: false,
				searchProductCode: '',
				inventoryData: [],
				inventoryLoading: false,
				inventoryParams: {
					page: 1,
					limit: 10
				},
				fileList: [],
				headers: {},
				imgList: [],
				showImg: false,
				errorData: [],
				dialogErrorVisible: false,
				fbxFlienName: '',
				fbxLink: '',
				fbxPreName: [],
				labelFlienName: '',
				labelLink: '',
				labelPreName: [],
				labelTipText: '',
				preFFMFileList: [],
				ffmFileLink: '',
				newLabelFileLink: [],
				clearFileListFlag: false,
				clientCreateOrderSkuNum: 0,
				clientCreateOrderSwapNum: 0,
				orderProductList: [],
				skuModelUrl: '',
				uploadloading: false,
				oldFbaNo: '',
				deliveryPickerOptions: {
					disabledDate(time) {
						let nowDate = Date.now();
						let nowHour = new Date().getHours();
						if(nowHour < 15) {
							nowDate = nowDate - 24 * 60 * 60 * 1000;
						} else if(nowHour >= 15 && nowHour < 20) {
							nowDate = nowDate - 24 * 60 * 60 * 1000;
						}
						let nowDay = new Date(time).getDay();
						return nowDate > time.getTime() || nowDay == 5;
					},
					selectableRange: '10:00:00 - 18:00:00'
				},

				// 导入商品信息错误窗口
				dialogErrorVisible:false,
				errorData:[],

				saCityList: [],
				saCityLoading: false,
			};
		},
	computed: {
		rules() {
			const validateCode = (rule, value, callback) => {
				let reg = /[^\w\.\/]/ig;
				if(reg.test(value)) {
					callback(new Error(this.$t('commonInfo.numberAndLetterLimit')));
				} else {
					callback();
				}
			};
			const validateFbaNoLength = (rule, value, callback) => {
				if(this.dialogForm.order_category === 'FBA' && (value || '').length !== 12) {
					callback(new Error(this.$t('commonInfo.fbaNoLimit')));
				} else {
					callback();
				}
			};
			return {
				order_category: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.orderType'),
					trigger: 'blur'
				}],
				fba_no: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('tipsInfo.info'),
					trigger: 'blur'
				}, {
					validator: validateCode,
					trigger: 'blur'
				}, {
					validator: validateFbaNoLength,
					trigger: 'blur'
				}],
				fbaNoCode: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.fbaNoCode'),
					trigger: 'blur'
				}, {
					min: 8,
					max: 8,
					message: this.$t('commonInfo.fbaNoCodeLimit'),
					trigger: 'change'
				}, {
					validator: validateCode,
					trigger: 'blur'
				}],
				delivery_date: [{
					required: true,
					message: this.dialogForm.deliveryType == '1' ? this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.deliveryDate') : this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.pickupDate'),
					trigger: 'blur'
				}],
				receiver_address: [{
					required: true,
					message: this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.warhouseCode'),
					trigger: 'blur'
				}],
				receiver_detail_address: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.deliveryDest'),
					trigger: 'blur'
				}],
				clientAppointCount: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder'),
					trigger: 'blur'
				}],
				send_company: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + 'NOON ' + this.$t('commonInfo.companyId'),
					trigger: 'blur'
				}, {
					min: 5,
					max: 6,
					message: this.$t('commonInfo.companyLimit'),
					trigger: 'blur'
				}],
				expressCompany: [{
					required: true,
					message: this.$t('tipsInfo.selectPlaceholder') + this.$t('ksaWhFBXOrderPage.deliveryPlatform'),
					trigger: 'blur'
				}],
				deliveryType: [{
					required: true,
					message: this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.deliveryMode'),
					trigger: 'blur'
				}],
				contacts: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + (this.dialogForm.deliveryType == '1' ? this.$t('commonInfo.contactMan') : this.$t('commonInfo.consigneeTypeOne')),
					trigger: 'blur'
				}],
				contactsTel: [{
					required: true,
					message: this.$t('tipsInfo.inputPlaceholder') + (this.dialogForm.deliveryType == '1' ? this.$t('commonInfo.contact') : this.$t('commonInfo.consigneeContact')),
					trigger: 'blur'
				}],
				destCity: [{
					required: true,
					message: this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.city'),
					trigger: 'blur'
				}]
			};
		}
	},
	watch: {
		'dialogForm.order_category': {
			immediate: true,
			handler(val) {
				this.dialogForm.receiver_address = '';
				this.selectWhList = [];
				this.dialogForm.deliveryType = '1';
				this.dialogForm.contacts = '';
				this.dialogForm.contactsTel = '';
				if (val != '' && val != null) {
					this.getWhDict(val);
				}
			}
		},
		'dialogForm.deliveryType': {
			immediate: true,
			handler(val) {
				this.dialogForm.contacts = '';
				this.dialogForm.contactsTel = '';
				if (val == '2') {
					this.dialogForm.receiver_address = 'Fleetan';
					// 获取fleetan海外仓信息
		            this.getWhDict('Fleetan');
				} else {
					this.dialogForm.receiver_address = '';
					this.getWhDict(this.dialogForm.order_category);
				}
			}
		},
		'dialogForm.receiver_address': {
			immediate: true,
			handler(val) {
				if (val != '' && val != null) {
					this.getWhInfo(val);
				}
			}
		},
		'dialogForm.delivery_date': function(newVal, oldVal) {
			if (!newVal) {
				return;
			}
			let nowDate = new Date();
			let chooseDate = new Date(newVal);
			let updateTime = '';
			if (this.isToday(chooseDate, nowDate)) {
				if (nowDate.getHours() < 15) {
					updateTime = '10:00:00 - 18:00:00';
				} else {
					updateTime = this.getTodayFirstSelectableHour(nowDate) + ':00:00 - 18:00:00';
				}
			} else {
				updateTime = '10:00:00 - 18:00:00';
			}
			this.$set(this.deliveryPickerOptions, 'selectableRange', updateTime);
			if ((this.dialogForm.order_category == 'FBA' || this.dialogForm.order_category == 'FBN') && this.isToday(chooseDate, nowDate) && chooseDate.getHours() < this.getTodayFirstSelectableHour(nowDate)) {
				this.dialogForm.delivery_date = newVal.split(' ')[0] + ' ' + this.getTodayFirstSelectableHour(nowDate) + ':00:00';
			}
		}
	},
	methods: {
		applyCustomerAddress(address) {
			this.dialogForm.destCity = address.city;
			this.dialogForm.receiver_detail_address = address.detailAddress;
			this.dialogForm.contacts = address.contactPerson;
			this.dialogForm.contactsTel = address.contactPhone;
		},
			isToday(date, nowDate = new Date()) {
				return date.getFullYear() == nowDate.getFullYear() && date.getMonth() == nowDate.getMonth() && date.getDate() == nowDate.getDate();
			},
			getTodayFirstSelectableHour(nowDate = new Date()) {
				return Math.min(15, Math.max(10, nowDate.getHours() - 4));
			},
			handleDialogClose() {
				this.$emit('update:visible', false);
				this.handleReset();
			},
			closeImg() {
				this.showImg = false;
			},
			handleViewImg(img) {
				this.imgList = [];
				if(img.indexOf(',') == -1){
					this.imgList.push(img[0])
				}else{
					this.imgList = img.split(',');
				}
				this.showImg = true;
			},
			handleSearchProduct() {
				let query = {
					companyProductCodeList:[],
					page:1,
					limit:10,
				}
				if(this.searchProductCode == ''){
					return this.$message.warning(this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.clientProductCode'));
				}else{
					query.companyProductCodeList = this.strToArr(this.searchProductCode);
					query.limit = query.companyProductCodeList.length;
				}
				this.inventoryParams = query;
				this.getInventoryList();
			},
			handleDownloadUrl() {
				window.open(this.skuModelUrl);
			},
			handleDeleteAll() {
				this.$confirm(this.$t('tipsInfo.deleteAllRowTips'), this.$t('tipsInfo.warning'), {
						confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
						cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
						type: "warning"
					}
					).then(() => {
						this.inventoryData = [];
						// 执行删除全部操作将上传文件地址清空
						this.dialogForm.skuListLink = '';
					})
					.catch(() => {});
			},
			handleDelete(code) {
				let that = this;
				this.$confirm(this.$t('tipsInfo.deleteRowTips'), this.$t('tipsInfo.warning'), {
						confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
						cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
						type: "warning"
					})
					.then(() => {
						var index = this.inventoryData.findIndex(item => {
							if(item.clientProductCode == code){
								return true;
							}
						})
						this.inventoryData.splice(index, 1);
						this.checkProduct();
						this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
					})
					.catch(() => {});
			},
			handleNum(row) {
				this.checkProduct();
			},
			getWhDict(type) {
				let dictText = '';
				switch (type) {
					case 'FBA':
						dictText = 'sys_SA_FBAWh';
						break;
					case 'FBN':
						dictText = 'sys_SA_NOONWh';
						this.labelTipText = this.$t('commonInfo.deliveryFileTips');
						break;
					case 'SB2B':
						dictText = 'sys_SA_NOONWh';
						this.labelTipText = this.$t('commonInfo.deliveryFileTips');
						break;
					case 'OWH':
						dictText = 'sys_SA_OtherWh';
						break;
					case 'DS':
						dictText = 'sys_SA_OtherWh';
						this.labelTipText = this.$t('commonInfo.barcodeFileTips');
						break;
					case 'FFM':
						this.labelTipText = this.$t('ksaWhFBXOrderPage.uploadFFMFileTips');
						this.getPlatformList();
						break;
					// 自提 仓库信息默认fleetan海外仓
			        case 'Fleetan':
    			        dictText = 'sys_SA_FleetanWh';
    			        break;
				}
				this.$http.get("/toborder/system/dict/data/list?dictType=" + dictText).then(res => {
					if (res.code == 200) {
						this.selectWhList = res.rows;
						if(type == 'OWH'){
							// 2026-03-26 zpy 放开客户端自定义仓库选择
							// this.selectWhList = this.selectWhList.filter(item => {
							// 	return item.dictValue != 'custom';
							// })

						}
						if(type == 'DS'){
							this.dialogForm.receiver_address = 'Noon - DS';
							this.dialogForm.receiver_detail_address = 'Noon - DS';
						}
						if (type == 'Fleetan') {// 如果为自提类型，默认上传固定仓库信息，不需要显示
						    let address = this.selectWhList[0].remark.split('###')[0];
						    let city = this.selectWhList[0].remark.split('###')[3];
        				    this.dialogForm.receiver_detail_address = address;
						    this.dialogForm.destCity = city;
        			    }
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {
					this.$message.error(err.msg);
				})
			},
			getWhInfo(val) {
				let that = this;
				setTimeout(function() {
					that.selectWhList.forEach(item => {
						if(val == 'custom'){
							// 自定义仓库清空详细地址 和联系人信息
							that.dialogForm.receiver_detail_address = '';
							that.dialogForm.contacts = '';
							that.dialogForm.contactsTel = '';
							that.getSaCityList();
						}else if (item.dictValue == val) {
						    if (item.dictValue == val) {
							let address = '', whCity = '';
							if(item.remark && item.remark.includes('&&&')){
								address = item.remark.split('&&&')[0];
								whCity = item.remark.split('&&&')[1];
							}else{
								address = item.remark;
							}
							that.dialogForm.receiver_detail_address = address;
							that.dialogForm.destCity = whCity;
						}
						}
					})
				}, 300)
			},
			// 获取沙特城市列表
			async getSaCityList() {
				if (this.saCityList.length > 0 || this.saCityLoading) {
					return;
				}
				this.saCityLoading = true;
				// 获取B2B空运城市地址 sys_b2bAirCity_list
				try {
					const cityRes = await this.$http.get("/toborder/system/dict/data/list", {
						params: { page: 1, limit: 100, dictType: 'sys_b2bAirCity_list' }
					});
					if (cityRes.code === 200) {
						this.saCityList = cityRes.rows;
					} else {
						this.$message.error(cityRes.msg);
					}
				} finally {
					this.saCityLoading = false;
				}
			    
			},
			// 获取派送平台列表
			async getPlatformList() {
				const res = await this.$http.get("/toborder/system/dict/data/list",{
				  params: {
						page:1,
						limit:100,
						dictType:'sys_ffm_delivery_platform'
					}
				});
				if (res.code === 200) {
					this.deliveryPlatformList = res.rows;
				} else {
				  this.$message.error(res.msg);
				}
			},
			getFBXInfo(data) {
				this.fbxLink = data;
				if(data != ''){
					//修改upload的preview预览
					let str = data.split("~");
					this.fbxPreName = [{
						name:str[1],
						url:data,
					}]
				}
			},
			getLabelInfo(data) {
				this.labelLink = data;
				if(data != ''){
					//修改upload的preview预览
					let str = data.split("~");
					this.labelPreName = [{
						name:str[1],
						url:data,
					}]
				}
			},
			getFFMFile(data){
				this.ffmFileLink = '';
				if (data.length > 0) {
					this.preFFMFileList = data;
					this.ffmFileLink = data[0].url;
				}
			},
			getNewLabelExcel(data) {
				this.newLabelFileLink = [];
				if(data.length > 0){
					data.forEach(item => {
						this.newLabelFileLink.push(item.url);
					})
				}
			},
			beforeUpload(file) {
				let fileNameStr = file.name;
				if(fileNameStr.length > 30){
					return this.$message.warning(this.$t('tipsInfo.uploadFileNameLimitTips'));
				}
				var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
				const extension = testmsg === "xls";
				const extension2 = testmsg === "xlsx";
				if (!extension && !extension2) {
					this.$message.warning(
						this.$t('tipsInfo.uploadExcelTypeTips')
					);
				}
				return extension || extension2;
			},
			handlesuccess(files, fileList) {
				this.uploadloading = false;
				if (files.code == 200) {
					let that = this;
					if(files.data.productErrorInfoList.length == 0){
						this.$message.warning(this.$t('ksaWhFBXOrderPage.checkProductErrorTips'));
					}else{
						if(!files.data.success){
							this.errorData = files.data.productErrorInfoList;
							this.dialogErrorVisible = true;
						}else{
							that.$message.success(this.$t('tipsInfo.uploadSuccess'));
							that.dialogForm.skuListLink = files.data.skuListLink;
							that.inventoryData = that.inventoryData.concat(files.data.productErrorInfoList);
							that.inventoryData = that.quchong(that.inventoryData);
							that.checkProduct();
						}
					}
				} else if (files.code == 500) {
					this.$message.error(files.msg);
				}
				if (files.code == 401) {
					this.$message.error(this.$t('tipsInfo.loginOutTips'));
					window.sessionStorage.removeItem("token");
					return this.$router.push({
						path: "/login"
					});
				}
			},
			handleError(err, file, fileList) {
				this.uploadloading = false;
			},
			handleProgress(event, file, fileList) {
				this.uploadloading = true;
			},
			getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = this.$t('commonInfo.secondTotal');
						return;
					}
					if (column.label == this.$t('commonInfo.orderQuantity')) {
						let gwSum = 0;
						data.map(item => {
							let gwValue = item.count;
							if (gwValue == null || gwValue == undefined) {
								gwValue = 0;
							}
							gwSum += Number(gwValue);
						});
						sums[index] = gwSum == 0 ? '' : gwSum;
						this.clientCreateOrderSkuNum = gwSum;
					} else if (column.label == this.$t('ksaWhFBXOrderPage.newLabelQuantity')) {
						let cwSum = 0;
						data.map(item => {
							let cwValue = item.swapCnt;
							if (cwValue == null || cwValue == undefined) {
								cwValue = 0;
							}
							cwSum += Number(cwValue);
						});
						sums[index] = cwSum == 0 ? '' : cwSum;
						this.clientCreateOrderSwapNum = cwSum;
					} else if (column.label == this.$t('commonInfo.appointmentQuantity')) {
						sums[index] = this.$t('commonInfo.secondTotal') + this.$t('commonInfo.orderQuantity') + ':';
					} else if (column.label == this.$t('ksaWhFBXOrderPage.newLabelCode')) {
						sums[index] = this.$t('commonInfo.secondTotal') + this.$t('ksaWhFBXOrderPage.newLabelQuantity') + ':';
					} else {
						sums[index] = '';
					}
				});
				return sums;
			},
			cellStyle({ row, column, rowIndex, columnIndex }) {
				if (row['isError'] == true) {
					return {
						background: 'burlywood'
					};
				}
			},
			//去重数组
			quchong(arr) {
				const res = new Map();
				return arr.filter(
					(list) => !res.has(list.clientProductCode) && res.set(list.clientProductCode, 1)
				);
			},
			submit() {
				if(this.dialogForm.order_category == 'FBA'){
					if(this.fbxLink == '' || this.fbxLink == null){
						this.$message.warning(this.$t('tipsInfo.submitOrderDeliveryMarkTips'));
						return; 
					}
				}
				if(this.dialogForm.order_category == 'FBN' || this.dialogForm.order_category == 'SB2B' || this.dialogForm.order_category == 'DS'){
					if(this.labelLink == '' || this.labelLink == null){
						this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.labelTipText.split('-')[0]);
						return; 
					}
				}
				if(this.dialogForm.order_category == 'FFM'){
					if(this.ffmFileLink == '' || this.ffmFileLink == null){
						this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.$t('commonInfo.deliveryFile'));
						return; 
					}
				}
				if(this.hasSkuNewItem){
					if(this.newLabelFileLink.length == 0){
						this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.$t('commonInfo.newLabelFile'));
						return; 
					}
				}
				let isOver = false,
					product = [];
				if (this.inventoryData.length == 0) {
					return this.$message.warning(this.$t('ksaWhFBXOrderPage.selectProductTips'));
				}
				this.inventoryData.forEach(item => {
					if (item.count != '') {
						if (parseInt(item.count) > parseInt(item.productQuantity) - parseInt(item.appointmentQuantity)) {
							isOver = true;
						} else {
							product.push({
								sku_old: item.clientProductCode,
								product_amount: item.count,
								sku_new:item.skuNew,
								swap_cnt:item.swapCnt,
								marks: '1',
							})
						}
					}
				})
				if (isOver) {
					return this.$message.warning(this.$t('ksaWhFBXOrderPage.overOrderCountTips'));
				}
				if(this.dialogForm.order_category == 'OWH'){
					let deliveryDate = new Date(this.dialogForm.delivery_date);
					let hour = this.isToday(deliveryDate) ? this.getTodayFirstSelectableHour() : 10;
					this.dialogForm.delivery_date = this.dialogForm.delivery_date.split(' ')[0] + ' ' + hour + ':00:00';
				}
				this.dialogForm.productList = product;
				this.dialogForm.order_box_mark = this.fbxLink;
				if(this.dialogForm.order_category == 'FFM'){
					this.dialogForm.label_url = this.ffmFileLink;
					this.dialogForm.fba_no = 'FFM' + Date.now();
					this.dialogForm.receiver_address = 'Fleetan WH'
				}else{
					this.dialogForm.label_url = this.labelLink;
				}
				this.dialogForm.newLabelLinkList = this.newLabelFileLink;
				let url = '';
				if (this.isEdit) {
					this.dialogForm.update_identity = true;
					if(this.oldFbaNo == this.dialogForm.fba_no){
						delete this.dialogForm.fba_no;
					}
					delete this.dialogForm.order_box_mark;
					if(JSON.stringify(this.orderProductList) === JSON.stringify(this.dialogForm.productList)){
						this.dialogForm.productList = [];
					}
					url = '/toborder/wms/fulfillment/update';
				} else {
					url = '/toborder/wms/fulfillment/add';
				}
				this.$refs["OrderForm"].validate(valid => {
					if(valid){
						let isUrgent = false;
						let nowDate = new Date();
						let chooseDate = new Date(this.dialogForm.delivery_date);
						if(nowDate.getDate() == chooseDate.getDate() && nowDate.getHours() > 15){
							isUrgent = true;
						}
						if(this.clientCreateOrderSkuNum == parseInt(this.dialogForm.clientAppointCount)){
							if(isUrgent){
								this.$confirm(
										"<p style='color:#ff6868;font-weight:bold;'>"+ this.$t('ksaWhFBXOrderPage.urgentOrderTip') +"</p>" +
										 '<p>'+this.$t('ksaWhFBXOrderPage.confirmToCreateOrderTips')+'</p>',
										  this.$t('tipsInfo.tip'), {
											dangerouslyUseHTMLString: true,
											confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
											cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
											type: "warning"
										}
									).then(() => {
										this.submitOrderInfo(url);
									})
									.catch(() => {});
							}else{
								this.submitOrderInfo(url);
							}
						}else{
							let str = '';
							if(isUrgent){
								str = this.$t('ksaWhFBXOrderPage.urgentOrderTip');
							}
							this.$confirm(
								"<p style='color:#ff6868;font-weight:bold;'>"+ str +"</p>" +
								"<p>"+ this.$t('ksaWhFBXOrderPage.orderCountDiffTips') +"</p>" +
								 '<p>'+this.$t('ksaWhFBXOrderPage.orderCountTips')+'：<span style="color:red;">'+ this.clientCreateOrderSkuNum +'</span></p>' +
								 '<p>'+this.$t('commonInfo.expectedDeliveryQuantity')+'：<span style="color:red;">' + this.dialogForm.clientAppointCount + '</span></p>' +
								 '<p>'+this.$t('ksaWhFBXOrderPage.confirmToCreateOrderTips')+'</p>',
								  this.$t('tipsInfo.tip'), {
									dangerouslyUseHTMLString: true,
									confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
									cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
									type: "warning"
								}
								).then(() => {
									this.submitOrderInfo(url);
								})
								.catch(() => {});
						}
					}
				})
			},
			handleDel() {
				this.$confirm(
						this.$t('ksaWhFBXOrderPage.deleteOrderTips'),
						this.$t('tipsInfo.warning'), {
							confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
							cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
							type: "warning"
						}
					).then(() => {
						this.$http
							.post("/toborder/wms/fulfillment/del", {
								fbaOrderIds: [this.dialogForm.customer_order_no],
							})
							.then(res => {
								if (res.code === 200) {
									this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
									this.$emit('update:visible', false);
									this.$emit('refreshList');
								} else {
									this.$message.error(res.msg);
								}
							});
					})
					.catch(() => {});
			},
			checkProduct() {
				if(this.inventoryData.length == 0){
					return
				}
				let dupList = findDuplicates(this.inventoryData,'clientProductCode');
				if(dupList.length > 0){
					let totalSku = dupList.reduce((sum, item) => sum + item.count, 0);
					if(totalSku > (dupList[0].productQuantity - dupList[0].appointmentQuantity)){
						let dupIndex = this.inventoryData.findIndex(item => item.clientProductCode == dupList[0].clientProductCode);
						this.inventoryData[dupIndex].isError = true;
						this.inventoryData[dupIndex].errorNum = true;
					}
				}
				let that = this;
				let isAllRight = true;
				this.hasSkuNewItem = false;
				const ruleInt = /^\+?[1-9][0-9]*$/;
				this.inventoryData.forEach(item => {
					item.isError = false;
					item.errorNum = false;
					item.errorNewSku = false;
					item.errorNewNum = false;
					if(!ruleInt.test(item.count)){
						item.isError = true;
						item.errorNum = true;
					}
					if(item.count > (item.productQuantity - item.appointmentQuantity)){
						item.isError = true;
						item.errorNum = true;
					}
					if(item.skuNew != ""){
						if(item.swapCnt == 0 || item.swapCnt == ''){
							item.isError = true;
							item.errorNewNum = true;
						}else{
							this.hasSkuNewItem = true;
						}
					}
					if(item.swapCnt != "" && item.swapCnt != 0){
						if(item.skuNew == ""){
							item.isError = true;
							item.errorNewSku = true;
						}else{
							this.hasSkuNewItem = true;
						}
						if(item.swapCnt > item.count){
							item.isError = true;
							item.errorNewNum = true;
						}
					}
					if(item.isError){
						isAllRight = false;
					}
				})
				this.openBtn = isAllRight?true:false;
			},
			submitOrderInfo(url) {
				this.submitLoading = true;
				this.$http.post(url, this.dialogForm).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tipsInfo.success'));
						this.submitLoading = false;
						this.$emit('update:visible', false);
						this.$emit('refreshList');
					} else {
						this.submitLoading = false;
						if(res.data && res.data.length > 0){
				            this.errorData = res.data;
				            this.dialogErrorVisible = true;
			            }else{
				            this.$message.error(res.msg);
			            }
					}
				}).catch(error => {
					this.submitLoading = false;
					this.$message.error(error.msg);
				})
			},
			handleReset() {
				this.dialogForm = {
					order_category:'',
					skuListLink:'',
					label_url:'',
					newLabelLinkList:[],
					fba_no: '',
					delivery_date: '',
					receiver_address: '',
					receiver_detail_address: '',
					productList: [],
					clientAppointCount:'',
					send_company:'',
					exp:'',
					deliveryType:'1',
					contacts:'',
					contactsTel:'',
					destCity:'',
					expressCompany:'',
				};
				this.clientCreateOrderSkuNum = 0;
				this.clientCreateOrderSwapNum = 0;
				this.newLabelFileLink = [];
				this.clearFileListFlag = true;
				this.hasSkuNewItem = false;
				this.inventoryData = [];
				this.orderProductList = [];
				this.searchProductCode = '';
				this.fbxLink = '';
				this.fbxFlienName = '';
				this.fbxPreName = [];
				this.labelLink = '';
				this.labelFlienName = '';
				this.labelPreName = [];
				this.ffmFileLink = '';
				this.preFFMFileList = [];
				let that = this;
				setTimeout(function(){
					that.clearFileListFlag = false;
				},100)
			},
			getInventoryList() {
				this.inventoryLoading = true;
				this.$http.post("/toborder/wms/product/getWmsInventoryInformation", this.inventoryParams).then(res => {
					if (res.code === 200) {
						this.inventoryLoading = false;
						let dataList = res.data;
						if(dataList.length != 0){
							dataList.forEach(item => {
								item.isError = true;
								item.skuNew = '';
								item.swapCnt = '';
								if(item.productImages != null && item.productImages != ''){
									let img = JSON.parse(item.productImages);
									item.img = img;
								}
							});
						}
						const dataLength = this.inventoryData.length;
						this.inventoryData = this.inventoryData.concat(dataList);
						this.inventoryData = this.quchong(this.inventoryData);
						if(this.inventoryData.length == dataLength){
							this.$message({
								title: this.$t('tipsInfo.info'),
								message: this.$t('ksaWhFBXOrderPage.checkProductTips'),
								duration: 3000,
								type: 'warning'
							});
						}
						this.checkProduct();
					} else {
						this.inventoryLoading = false;
						this.$message.error(res.msg);
					}
				}).catch(error => {
					this.inventoryLoading = false;
					this.$message.error(error.msg);
				})
			},
			getModelUrl() {
				this.$http.get("/toborder/system/dict/data/list", {
					params: {
						page: 1,
						limit: 10,
						dictType: 'sys_template_url'
					}
				}).then(res => {
					if (res.code === 200) {
						let data = res.rows;
						data.forEach(item => {
							if(item.dictLabel == 'fulfillment FBX订单下单模版'){
								this.skuModelUrl = item.remark;
							}
						});
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {
					this.$message.error(err.msg);
				})
			},
		},
		created() {
			let token = window.sessionStorage.getItem("token");
			this.headers = {
				Authorization: token,
			};
			this.getModelUrl();
		},
		mounted() {}
	};
</script>

<style scoped>
.deliveryTip {
	width: 630px;
	margin-left: 150px;
	margin-bottom: 10px;
	background-color: #fffdd6;
	border-radius: 4px;
	padding: 5px 10px;
}

.deliveryTip h4 {
	margin: 0;
	line-height: 30px;
}

.deliveryTip i {
	margin: 0 5px;
}

.deliveryTip span {
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 20px;
}

.deliveryTip label {
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 40px;
	font-weight: bold;
}

.fileUploadBtn {
	float: left;
	margin: 0 10px;
	max-width: 220px;
}

.dialog-footer {
	text-align: center;
}

/* 阿拉伯语样式 */
[lang="ar"] {
	.deliveryTip {
		margin-left: 0;
		margin-right: 150px;
	}
	
	.fileUploadBtn {
		float: right;
		margin: 0 10px;
		max-width: 220px;
	}
	
	::v-deep .el-dialog__headerbtn {
		right: auto;
		left: 20px;
	}
	
	::v-deep .el-dialog__footer {
		text-align: left;
		.el-button {
			margin: 0 10px;
		}
	}
}
</style>
